import { render, staticRenderFns } from "./pro.vue?vue&type=template&id=5f56c3e5&scoped=true"
import script from "./pro.vue?vue&type=script&lang=js"
export * from "./pro.vue?vue&type=script&lang=js"
import style0 from "./pro.vue?vue&type=style&index=0&id=5f56c3e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56c3e5",
  null
  
)

export default component.exports